/**
 * Every return rate is reported on matured orders only, so each tooltip has to
 * say so — a reader who does not know that reads an unfinished rate as a low
 * one.
 */
const MATURITY_NOTE_EN =
  "\nThe rate only counts orders at least 30 days old, so returns have had time to arrive — which is why it reads N/A until the store has been connected that long.";

export const translationStatistics_en_part4 = {
  notificationsDeleteError: "Error deleting notification",
  notificationTopics: [
    { emne: "Abonnement & medlemskab", label: "Subscription & membership" },
    { emne: "Annullering", label: "Cancellation" },
    { emne: "Andet", label: "Other" },
    { emne: "Åbningstider", label: "Opening hours" },
    { emne: "Bestilling", label: "Order" },
    { emne: "Betaling", label: "Payment" },
    { emne: "Booking", label: "Booking" },
    { emne: "Butikker", label: "Stores" },
    { emne: "FAQ", label: "FAQ" },
    { emne: "Fitness rådgivning", label: "Fitness advice" },
    { emne: "Fortrydelsesret", label: "Right of withdrawal" },
    { emne: "Garanti", label: "Warranty" },
    { emne: "Generel", label: "General" },
    { emne: "Informationsforespørgsel", label: "Information request" },
    {
      emne: "Kalorieberegner/Kostplan",
      label: "Calorie calculator / meal plan",
    },
    { emne: "Kampagner & rabatter", label: "Campaigns & discounts" },
    { emne: "Kontakt", label: "Contact" },
    { emne: "Kundeservice", label: "Customer service" },
    { emne: "Lagerstatus", label: "Stock status" },
    { emne: "Levering", label: "Delivery" },
    { emne: "Medlemskab", label: "Membership" },
    { emne: "Ordre", label: "Order" },
    { emne: "Pris og rabat", label: "Price and discount" },
    { emne: "Problem med shoppen", label: "Problem with the shop" },
    { emne: "Produkt anbefaling", label: "Product recommendation" },
    { emne: "Produktinformation", label: "Product information" },
    { emne: "Profil", label: "Profile" },
    { emne: "Refundering", label: "Refund" },
    { emne: "Reklamation", label: "Complaint" },
    { emne: "Reservation", label: "Reservation" },
    { emne: "Returnering", label: "Return" },
    { emne: "Support", label: "Support" },
    { emne: "Teknisk", label: "Technical" },
    { emne: "Tilbud", label: "Offer" },
    { emne: "Vask selv", label: "Self-service wash" },
    { emne: "Contact & support", label: "Contact & support" },
    { emne: "Fejl på shoppen", label: "Shop error" },
    { emne: "Kompatabilitet", label: "Compatibility" },
    { emne: "Kontakt & support", label: "Contact & support" },
    { emne: "Konto & login", label: "Account & login" },
    { emne: "Produktvalg", label: "Product choice" },
    { emne: "Support og Kontakt", label: "Support and contact" },
  ],

  // Settings placeholder translations

  // Settings placeholder translations
  settingsComingSoon: "Settings Coming Soon",
  settingsComingSoonDescription:
    "Statistics settings and preferences will be available in a future update. Stay tuned for more customization options!",

  // Contact formula tracking translations

  // Contact formula tracking translations
  totalContactFormulas: "Used Contact Formulas",
  contactFormulas: "Contact Formulas",
  contactFormulaConversionRate: "Used contact form",

  // Tooltip translations for info icons

  // Tooltip translations for info icons
  totalMessagesTooltip:
    "The total number of messages sent by users to the chatbot during the selected period",
  avgMessagesPerDayTooltip:
    "Average number of user messages per day based on days that had activity",
  totalConversationsTooltip:
    "The total number of conversations (sessions) started with the chatbot during the selected period",
  totalUserRatingsTooltip:
    "Number of times users have given a rating or feedback after their conversation",
  averageRatingTooltip: "Average rating given by users after their conversation with the chatbot",
  thumbsUpPercentageTooltip: "Percentage of users who gave a positive rating (thumbs up)",
  csatScoreTooltip:
    "Customer Satisfaction score - percentage of ratings that were 4 stars or higher (or thumbs up)",
  chatbotSatisfactionTooltip:
    "Chatbot Satisfaction - CSAT score calculated only from conversations that did not result in a fallback to human customer service",
  totalPurchasesTooltip:
    "Number of registered purchases from users who have had a conversation with the chatbot.\nWe track conversions until the customer clicks 'Pay' and opens the external payment window.",
  totalRevenueTooltip:
    "Total revenue from purchases made by users who have interacted with the chatbot.\nWe track conversions until the customer clicks 'Pay' and opens the external payment window.",
  storeTotalPurchasesTooltip:
    "All orders tracked in the connected store (Shopify or Orders API) during the period, whether or not the customer talked to the chatbot.",
  storeTotalRevenueTooltip:
    "Total revenue from all orders in the connected store (Shopify or Orders API) during the period, whether or not the customer talked to the chatbot.",
  storeAveragePurchaseValueTooltip:
    "Average value of all orders in the connected store (Shopify or Orders API) during the period, whether or not the customer talked to the chatbot (store revenue divided by order count).",
  returnRateTooltip:
    "Share of orders from users who talked to the chatbot where at least one item was sent back." +
    MATURITY_NOTE_EN +
    "\nNote: customers who ask the chatbot are not a random sample of customers, so a gap against the store rate is not on its own evidence of the chatbot's effect.",
  returnValueRateTooltip:
    "Value of items sent back as a share of order value, for users who talked to the chatbot.\nOnly genuine returns count — cancellations and goodwill refunds do not." +
    MATURITY_NOTE_EN,
  returnUnitRateTooltip:
    "Items sent back as a share of items bought, for users who talked to the chatbot.\nThe most faithful rate where customers often return part of an order." +
    MATURITY_NOTE_EN,
  storeReturnRateTooltip:
    "Share of all orders in the connected store (Shopify or Orders API) where at least one item was sent back, whether or not the customer talked to the chatbot." +
    MATURITY_NOTE_EN,
  storeReturnValueRateTooltip:
    "Value of items sent back as a share of order value, across all orders in the store." +
    MATURITY_NOTE_EN,
  storeReturnUnitRateTooltip:
    "Items sent back as a share of items bought, across all orders in the store." +
    MATURITY_NOTE_EN,
  returnCohortBasisTooltip:
    "How many orders the rate is based on, and the minimum age they must reach.",
  storeConversionRateTooltip:
    "Share of store visits that ended in a purchase (all orders divided by store sessions).\nSessions are measured by the Shopify web pixel, so the rate only covers the time since the pixel became active.",
  storeConversionRateVisitorsTooltip:
    "Store orders divided by daily visitors, as the chatbot counts them: each browser once a day, on pages where the chatbot loads.\nVisitors who decline non-essential cookies are not counted, so the rate reads higher than one over every visitor. Only web orders placed since visitors were first counted are included.",
  averagePurchaseValueTooltip:
    "Average value of purchases made by users who have interacted with the chatbot.\nWe track conversions until the customer clicks 'Pay' and opens the external payment window.",
  conversionRateTooltip:
    "How many percent ended up making a purchase after having a conversation with the chatbot.\nWe track conversions until the customer clicks 'Pay' and opens the external payment window.",
  fallbackRateTooltip: "The chatbot did not know the answer, so it recommended customer service",
  resolutionRateTooltip:
    "Percentage of sessions resolved by the bot without requiring customer service as the next step",
  handoverRequiredRateTooltip:
    "Percentage of sessions where the case genuinely required customer service or a manual process",
  userRequestedCustomerServiceRateTooltip:
    "Percentage of sessions where the user explicitly asked for customer service, livechat, or support",
  ligegyldigRateTooltip:
    'AI estimate of how many percent of conversations consist only of meaningless messages like "hi" without actual content',
  totalContactFormulasTooltip:
    "Number of conversations where the customer submitted a contact form or support request. You can view these contact formulas by using the filter button on the conversations page",
  contactFormulaConversionRateTooltip:
    "Percentage of conversations where the customer used the contact form or submitted a support request",
  engagementRate: "Engagement Rate",
  engagementRateTooltip:
    "Percentage of visitors who opened the chatbot and actually sent a message",
  conversationSources: "Conversation sources",
  conversationSourcesTooltip:
    "Shows how conversations were started across different integration sources",
  viewContactFormulas: "View contact formulas",
  tagsViewExplanation:
    "You can see conversations in each tag and category by filtering with the small filter button on the conversations page",
  clickToViewTags: "Click to view tags",
  tagDistribution: "Tag Distribution",
  tagDistributionFor: "Tag Distribution for",
  tagDistributionDescription: "Tags associated with this topic:",
  noTagsFound: "No tags found for this topic.",

  // Modal translations

  // Modal translations
  qualityMetrics: "Quality Metrics",
  statisticsFor: "Statistics for",
  close: "Close",
  goToConversations: "View conversations",
  viewPurchases: "View purchases",
  viewLeads: "View leads",
  lackingInfoRate: "Lacking info rate",
  leads: "Contact form",
  viewConversations: "View conversations",

  companyInfoPlaceholderDescription:
    "Enter company information, industry, and any context that will help the AI generate better insights",
  // Error message translations
  // Error message translations
  uploadFailedContentTooLong:
    "Upload failed: Content is too long for processing. Try breaking into smaller sections or use PDF upload with automatic chunking.",
  uploadFailedAIProcessing:
    "Upload failed: AI processing error. Please check your content and try again.",
  uploadFailedInvalidExpiration: "Upload failed: Invalid expiration date format.",
  uploadFailedInvalidSchedule: "Upload failed: Invalid schedule time format.",
  uploadFailedUserNotFound: "Upload failed: Selected user not found. Please refresh and try again.",
  uploadFailedMissingFields:
    "Upload failed: Missing required information. Please fill in all fields.",
  uploadFailedAuthError: "Upload failed: User authentication error. Please log in again.",
  uploadFailedNetwork:
    "Upload failed: Network connection issue. Please check your connection and try again.",
  uploadFailedTimeout: "Upload timed out. Please try again or reduce upload size.",
  uploadFailedAuthExpired: "Upload failed: Authentication expired. Please log in again.",
  uploadFailedServerError: "Error: please contact Diverge.",
  uploadFailedGeneric: "Upload failed: {error}",
  contentMayNeedChunking:
    "Warning: Content is estimated at {tokens} tokens, which may require chunking for processing. Consider breaking into smaller sections if upload fails.",
  pleaseSelectUser: "Please select a user.",
  pleaseSelectUserBase: "Please select a user",
  fromAccessibleUsers: "from your accessible users",
  toManageTheirData: "to manage their data",
  pleaseSelectOrganization: "Please select an organization.",
  pleaseSelectOrganizationToManage: "Please select an organization to manage their data",
  selectOrganization: "Select Organization",
  selectOrganizationPlaceholder: "Select organization",
  noDataFoundForOrganization: "No data found for {name}",
  errorFetchingOrganizations: "Error fetching organizations",
  // Additional error and UI messages,
};
